import { action } from 'mobx';
import { translate } from 'core/utils';

class UserSettingStore {
	constructor(rootStore) {
		this.rootStore = rootStore;
		this.settings = this.id = null;
		this.service = rootStore.app.baasic.userProfileModule.profile;
		this.create = false;
	}

	@action.bound async setSetting(key, value) {
		if (!this.rootStore.authStore.user || !this.rootStore.authStore.user.id) {
			throw new Error('Cannot set settings, not logged in');
		}
		if ((await this.getSetting(key, null)) === value) {
			// No operation, value identical
			return;
		}
		this.settings[key] = value;

		try {
			const updateSettings = { ...this.settings };
			updateSettings.id = this.id;
			if (!this.create) {
				await this.service.update(updateSettings);
			} else {
				await this.service.create(updateSettings);
				this.create = false;
			}
		} catch ({ statusCode }) {
			if (statusCode) {
				this.rootStore.notificationStore.warning('SETTINGSERROR' + statusCode);
			} else {
				this.rootStore.notificationStore.error('INTERNALERROR');
			}
		}
	}

	@action.bound async getSetting(key, defaultValue = null) {
		if (!this.rootStore.authStore.user || !this.rootStore.authStore.user.id) {
			throw new Error(translate('SETTINGSAUTHERROR'));
		}
		if (!this.id || this.id !== this.rootStore.authStore.user.id) {
			try {
				const { data } = await this.service.get(this.rootStore.authStore.user.id);
				if (data) {
					this.create = false;
					this.settings = data;
				} else {
					this.create = true;
					this.settings = {};
				}
			} catch (err) {
				if (err.statusCode === 404) {
					this.create = true;
					this.settings = {};
				} else {
					throw err;
				}
			}
			this.id = this.rootStore.authStore.user.id;
		}
		if (key in this.settings) {
			return this.settings[key];
		}
		return defaultValue;
	}
}

export default UserSettingStore;



// WEBPACK FOOTER //
// ./src/core/stores/UserSettingStore.js